(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  label: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  placeholder: _propTypes.string,
  theme: _propTypes.string,
  value: _propTypes.string
};
var SearchInputRow = function SearchInputRow(props) {
  var value = props.value,
    theme = props.theme,
    placeholder = props.placeholder,
    label = props.label,
    onChange = props.onChange;
  var themeClass = theme ? "hl__search-input-row--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__search-input-row ".concat(themeClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-input-row__container"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "hl__search-input-row__label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__search-input-row__text"
  }, label), /*#__PURE__*/_react["default"].createElement("input", {
    className: "hl__input hl__search-input-row__input",
    name: "keyword",
    type: "text",
    placeholder: placeholder,
    value: value,
    onChange: onChange
  }))));
};
SearchInputRow.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = SearchInputRow;

},{"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  label: _propTypes.string,
  columns: _propTypes.number,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    title: _propTypes.string.isRequired,
    description: _propTypes.string,
    external_link: _propTypes.string,
    internal_link: _propTypes.string.isRequired
  })).isRequired
};
var GroupedList = function GroupedList(props) {
  var renderExternalTitle = function renderExternalTitle(item) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "hl__link-tag hl__grouped-list__title hl__grouped-list__title--external",
      href: item.external_link
    }, /*#__PURE__*/_react["default"].createElement("span", null, item.title), /*#__PURE__*/_react["default"].createElement("span", {
      "class": "hl__link-tag__external-icon hl__link-tag__external-icon--blue"
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20"
    }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
      transform: "translate(-906 -1005)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M923.78 1022.78V1015H926v7.78c0 1.22-1 2.22-2.22 2.22h-15.56c-1.23 0-2.22-1-2.22-2.22v-15.56c0-1.22.99-2.22 2.22-2.22H916v2.22h-7.78v15.56zm-5.71-17.78H926v7.93h-2.27v-4.07L912.6 1020l-1.6-1.6 11.14-11.13h-4.07z"
    }))))));
  };
  var renderInternalTitle = function renderInternalTitle(item) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "hl__link-tag hl__grouped-list__title",
      href: item.internal_link
    }, item.title);
  };
  var renderExternalDescription = function renderExternalDescription(item) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "hl__grouped-list__description"
    }, item.description, " (", /*#__PURE__*/_react["default"].createElement("a", {
      className: "hl__link-tag",
      href: item.internal_link,
      title: "More information about ".concat(item.title)
    }, "more info..."), ")");
  };
  var renderInternalDescription = function renderInternalDescription(item) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "hl__grouped-list__description"
    }, item.description);
  };
  var renderDD = function renderDD(items) {
    return items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("dd", {
        className: "hl__grouped-list__item",
        key: item.id
      }, item.external_link && renderExternalTitle(item), !item.external_link && renderInternalTitle(item), item.description && item.external_link && renderExternalDescription(item), item.description && !item.external_link && renderInternalDescription(item));
    });
  };
  var renderLI = function renderLI(items) {
    return items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: "hl__grouped-list__item",
        key: item.id
      }, item.external_link && renderExternalTitle(item), !item.external_link && renderInternalTitle(item), item.description && item.external_link && renderExternalDescription(item), item.description && !item.external_link && renderInternalDescription(item));
    });
  };
  var _props$columns = props.columns,
    columns = _props$columns === void 0 ? 1 : _props$columns,
    items = props.items,
    _props$label = props.label,
    label = _props$label === void 0 ? "" : _props$label;
  var columnClass = "hl__grouped-list--".concat(columns);
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__grouped-list ".concat(columnClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__grouped-list__container"
  }, label && /*#__PURE__*/_react["default"].createElement("dl", {
    className: "hl__grouped-list__items hl__grouped-list__items--dl"
  }, /*#__PURE__*/_react["default"].createElement("dt", {
    className: "hl__grouped-list__label"
  }, label), renderDD(items)), !label && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "hl__grouped-list__items hl__grouped-list__items--ul"
  }, renderLI(items))));
};
GroupedList.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = GroupedList;

},{"prop-types":"prop-types","react":"react"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jquery = _interopRequireDefault(require("jquery"));
var _ramda = _interopRequireDefault(require("ramda"));
var _queryString = _interopRequireDefault(require("query-string"));
var _searchInputRow = _interopRequireDefault(require("../../02-molecules/forms/search-input-row.jsx"));
var _groupedList = _interopRequireDefault(require("../../02-molecules/lists/grouped-list.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AlphaDirectory = exports["default"] = /*#__PURE__*/function (_Component) {
  function AlphaDirectory(props) {
    var _this;
    _classCallCheck(this, AlphaDirectory);
    _this = _callSuper(this, AlphaDirectory, [props]);
    // function takes two optional values
    // the url parameter and the value it should equal
    // if neither a parameter or value are passed,
    // we assume the queryString has been updated else where
    // and we just need to reset the url
    _defineProperty(_this, "updateUrl", function (param) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // if a parameter and a value are passed add the new value
      if (param && value) {
        _this.queryString[param] = value;
      }
      // if a parameter is passed with a value remove the parameter
      if (param && (value === null || value.length === 0)) {
        delete _this.queryString[param];
      }
      var stringifiedQueries = _queryString["default"].stringify(_this.queryString);
      var newUrl = window.location.origin + window.location.pathname + "?" + stringifiedQueries;
      window.history.replaceState({
        path: newUrl
      }, "", newUrl);
    });
    /********** End Data Manipulation ***************/
    /********** Event Handlers ***************/
    _defineProperty(_this, "onKeywordChange", function (event) {
      var filterKeyword = Object.assign({}, _this.state.filterKeyword);
      var value = event.target.value;
      filterKeyword.value = value;
      _this.updateUrl(filterKeyword.param, value);
      _this.setState({
        filterKeyword: filterKeyword
      });
      _this.fetchResults();
    });
    _this.queryString = _queryString["default"].parse(location.search); // params in the url

    var placeholder = 'Try "bookmarklet"';
    var label = "Search Services & Tools";
    _this.state = {
      filterKeyword: {
        label: label,
        param: "filter",
        onChange: _this.onKeywordChange,
        placeholder: placeholder,
        theme: _this.props.theme || "",
        value: _this.queryString.filter || ""
      },
      results: {
        items: {}
      }
    };
    _this.$ajaxResults = _jquery["default"].ajax();
    _this.emptyMessage = "Loading...";
    return _this;
  }
  _inherits(AlphaDirectory, _Component);
  return _createClass(AlphaDirectory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchResults();
      this.emptyMessage = "No Results";
    }

    /********** Data Fetching ***************/
  }, {
    key: "fetchResults",
    value: function fetchResults() {
      var _this2 = this;
      var activeFilters = Object.assign({
        _format: "json"
      }, this.queryString);
      this.$ajaxResults.abort();
      this.$ajaxResults = _jquery["default"].ajax({
        url: this.props.requestUrl,
        // cache: false,
        data: activeFilters
      });
      this.$ajaxResults.done(function (data) {
        var results = {
          items: {}
        };
        if (typeof data.results.items === "undefined" || data.results.items.length === 0) {
          _this2.setState({
            results: results
          });
          return;
        }
        results.items = data.results.items;
        _this2.setState({
          results: results
        });
      }).fail(function (xhr, status, error) {
        console.warn("failed to fetch results");
        var results = {
          items: {}
        };
        _this2.setState({
          results: results
        });
      });
    }
    /********** End Data Fetching ***************/

    /********** Data Manipulation ***************/
  }, {
    key: "renderResults",
    value: function renderResults(results) {
      var filterKeyword = this.state.filterKeyword;
      var keys = Object.keys(results);
      if (filterKeyword.value) {
        return keys.map(function (key) {
          return /*#__PURE__*/_react["default"].createElement(_groupedList["default"], {
            key: key,
            columns: 1,
            items: results[key]
          });
        });
      } else {
        return keys.map(function (key) {
          return /*#__PURE__*/_react["default"].createElement(_groupedList["default"], {
            key: key,
            columns: 1,
            label: key,
            items: results[key]
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        filterKeyword = _this$state.filterKeyword,
        results = _this$state.results;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__alpha-directory__app"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__alpha-directory__filters"
      }, /*#__PURE__*/_react["default"].createElement(_searchInputRow["default"], filterKeyword)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__alpha-directory__results"
      }, !_ramda["default"].isEmpty(results.items) && /*#__PURE__*/_react["default"].createElement("div", null, this.renderResults(results.items)), _ramda["default"].isEmpty(results.items) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__alpha-directory__no-results"
      }, this.emptyMessage)));
    }
  }]);
}(_react.Component);
_defineProperty(AlphaDirectory, "propTypes", {
  requestUrl: _propTypes.string.isRequired,
  assetsUrl: _propTypes.string.isRequired,
  theme: _propTypes.string,
  pageType: _propTypes.string
});

},{"../../02-molecules/forms/search-input-row.jsx":1,"../../02-molecules/lists/grouped-list.jsx":2,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","ramda":"ramda","react":"react"}],4:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _alphaDirectoryApp = _interopRequireDefault(require("./alpha-directory-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-alpha-directory-app");
if (el) {
  var props = {
    requestUrl: el.getAttribute("data-request-url"),
    assetsUrl: el.getAttribute("data-assets-url"),
    pageType: el.getAttribute("data-page-type")
  };
  props.requestUrl = "".concat(props.requestUrl, "/api/v1/services");
  props.theme = "";
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_alphaDirectoryApp["default"], props), el);
}

},{"./alpha-directory-app.jsx":3,"react":"react","react-dom":"react-dom"}],5:[function(require,module,exports){
"use strict";

var _alphaDirectory = _interopRequireDefault(require("../_patterns/04-templates/content-types/alpha-directory.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

},{"../_patterns/04-templates/content-types/alpha-directory.js":4}]},{},[5]);
